export default "<app-product3 [prodId]=\"'mortgage'\"></app-product3>\n<app-clientslogo></app-clientslogo>"